import { render, staticRenderFns } from "./RrcvPD_Details.vue?vue&type=template&id=bf09f4f6"
import script from "./RrcvPD_Details.vue?vue&type=script&lang=js"
export * from "./RrcvPD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports